import React, { PureComponent } from "react";

import styles from "./CategoriesList.local.scss";
import classnames from "classnames";
import Category from "./Category";
import CategoryFetching from "./CategoryFetching/CategoryFetching";

export default class CategoriesListComponent extends PureComponent {
  renderTrees = () => {
    const { trees, lng } = this.props;
    if (trees && trees.length > 0)
      return trees.map(tree => {
        let i = 0;
        if (!tree || !tree.tree) {
          return null;
        }
        return (
          <li
            className="cell small-12 medium-6 large-4"
            key={`cat-${tree.id}-${i++}`}
          >
            <Category tree={tree} lng={lng} />
          </li>
        );
      });
    else return this.renderAddNewTree();
  };

  renderAddNewTree = () => {
    const { lng } = this.props;
    return (
      <li className="cell small-12 medium-6 large-4">
        <div className={classnames(styles.root, styles.branch)}>
          <Category tree={null} lng={lng} />
        </div>
      </li>
    );
  };

  renderFetching = () => {
    return [1, 2, 3].map(item => (
      <li className="cell small-12 medium-6 large-4">
        <CategoryFetching />
      </li>
    ));
  };
  render() {
    const { fetching } = this.props;

    return (
      <div className={styles.categories}>
        <ul className={classnames(styles.list, "grid-x")}>
          {fetching ? this.renderFetching() : this.renderTrees()}
          {!fetching && this.renderAddNewTree()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriesList/CategoriesListComponent.js